module.exports = __webpack_public_path__ + "static/assets/69f81e28826d7502e296e4f270b2b313.png";